import { Component, Fragment, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'qumra-search-button',
  styleUrl: 'qumra-search-button.css',
  shadow: true,
})
export class QumraSearchButton {

  @Prop() iconsize: string = '24px';
  @Prop() iconcolor: string = '#000';
  @State() searchOpen: boolean = false;

  toggleSearch() {
    this.searchOpen = !this.searchOpen;
  }

  hexToRgb(hex: string) {
    hex = hex.replace('#', '');
    if (hex.length === 3) {
      hex = hex.split('').map(x => x + x).join('');
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return {
      r: isNaN(r) ? 0 : r,
      g: isNaN(g) ? 0 : g,
      b: isNaN(b) ? 0 : b
    };
  }

  lightenColor(rgb: { r: number; g: number; b: number }, percentage: number) {
    return {
      r: Math.round(rgb.r + (255 - rgb.r) * percentage),
      g: Math.round(rgb.g + (255 - rgb.g) * percentage),
      b: Math.round(rgb.b + (255 - rgb.b) * percentage),
    };
  }

  render() {
    const rgbColor = this.hexToRgb(this.iconcolor);
    const lightenedColor = this.lightenColor(rgbColor, 0.9);
    const lightenedBadgeColor = `rgb(${lightenedColor.r}, ${lightenedColor.g}, ${lightenedColor.b})`;

    return (
      <Fragment>
        <a
        aria-label="searchAboutProduct"
          onClick={() => this.toggleSearch()}
          class="login-link qumra-search-button  transtion hover:scale-110"
          style={{ background: lightenedBadgeColor }}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M11 3.5C14.0376 3.5 16.5 5.96243 16.5 9C16.5 12.0376 14.0376 14.5 11 14.5C9.48101 14.5 8.10704 13.8852 7.11091 12.8891C6.11479 11.893 5.5 10.519 5.5 9C5.5 5.96243 7.96243 3.5 11 3.5ZM18 9C18 5.13401 14.866 2 11 2C7.13401 2 4 5.13401 4 9C4 10.6625 4.58031 12.1906 5.54828 13.3911L2.21967 16.7197C1.92678 17.0126 1.92678 17.4874 2.21967 17.7803C2.51256 18.0732 2.98744 18.0732 3.28033 17.7803L6.60894 14.4517C7.80944 15.4197 9.33748 16 11 16C14.866 16 18 12.866 18 9Z"
              fill={this.iconcolor} stroke={this.iconcolor} stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"
            />
          </svg>
        </a>
          <qumra-search-input search-open={this.searchOpen} class="qumra-w-full"></qumra-search-input>
      </Fragment>
    );
  }
}
